import { GIFT } from '../constants';
import { instance } from '../../axios';

const createGiftAction = (gift, companyId) => {
  return (dispatch) => {
    dispatch({
      type: GIFT.CREATE_GIFT,
    });
    instance
      .post('/gift/company/' + companyId, gift)
      .then((results) => {
        dispatch({
          type: GIFT.CREATE_GIFT_SUCCESS,
          payload: results.data,
        });
        dispatch(getGiftsAction());
      })
      .catch((error) => {
        dispatch({
          type: GIFT.CREATE_GIFT_FAILURE,
          payload: error,
        });
      });
  };
};

const updateGiftAction = (gift, id) => {
  return (dispatch) => {
    dispatch({
      type: GIFT.UPDATE_GIFT,
    });
    instance
      .post('/gift/' + id, gift)
      .then((results) => {
        dispatch({
          type: GIFT.UPDATE_GIFT_SUCCESS,
          payload: results.data,
        });
        dispatch(getGiftsAction());
      })
      .catch((error) => {
        dispatch({
          type: GIFT.UPDATE_GIFT_FAILURE,
          payload: error,
        });
      });
  };
};

const getGiftsAction = (companyId) => {
  return (dispatch) => {
    dispatch({
      type: GIFT.GET_GIFTS,
    });
    instance
      .get('/gift/company/' + companyId)
      .then((results) => {
        dispatch({
          type: GIFT.GET_GIFTS_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GIFT.GET_GIFTS_FAILURE,
          payload: error,
        });
      });
  };
};

const cleanGiftAction = () => {
  return (dispatch) => {
    dispatch({
      type: GIFT.CLEAN_GIFT,
    });
  };
};

export { createGiftAction, updateGiftAction, getGiftsAction, cleanGiftAction };
